<div class="order-footer">
  <div class="order-footer__stats"></div>
  @if (shop.platform !== 'woocommerce') {
    <div class="order-footer__save" [class.disabled]="fulfillService.orderHasPendingUpdates$ | async">
      @if (isPickingMode) {
        <pdq-button
          label="Save as partially picked"
          variant="secondary"
          [disabled]="isSaveActive"
          [loading]="loading"
          (onClick)="saveAsPartiallyPicked()"></pdq-button>
      }
      @if (!isPickingMode) {
        <pdq-button
          label="Save as partially fulfilled"
          variant="secondary"
          [disabled]="isSaveActive || isBundle()"
          [loading]="loading"
          (onClick)="saveAsPartiallyFulfilled()"></pdq-button>
      }
    </div>
  }
</div>
